import React, { useMemo } from 'react';
import VersionPreviewCard from './VersionPreviewCard';

import './ImportPreviewCreative.css';

const ImportPreviewCreative = ({ libraryId, creativeVersion, jobId }) => {
	const { creative, versions } = creativeVersion;
	const creativeVersions = useMemo(() => {
		if (versions && versions.length > 0) {
			return (<div className="versions-container">{versions.map((version) =>{
				const ftUtilsId = `place_${creative.id}_${version.name}`;
				return (<VersionPreviewCard key={ftUtilsId}
					libraryId={libraryId}
					creative={creative}
					version={version}
					ftUtilsId={ftUtilsId}
					jobId={jobId} />);
			})}</div>);
		}
	}, [versions]);

	return (
		<div className="import-preview-creative">
			<div className="creative-name">{creative.name}</div>
			{creativeVersions}
		</div>
	);
};

export default ImportPreviewCreative;
ImportPreviewCreative.displayName = "ImportPreviewCreative";
